/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Forced_SubtitleInputs */

const en_context_menu_forced_subtitle = /** @type {(inputs: Context_Menu_Forced_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forced Subtitle`)
};

const fr_context_menu_forced_subtitle = /** @type {(inputs: Context_Menu_Forced_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titre forcé`)
};

const de_context_menu_forced_subtitle = /** @type {(inputs: Context_Menu_Forced_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erzwungener Untertitel`)
};

const it_context_menu_forced_subtitle = /** @type {(inputs: Context_Menu_Forced_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitoli forzati`)
};

const ru_context_menu_forced_subtitle = /** @type {(inputs: Context_Menu_Forced_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принудительные субтитры`)
};

const es_context_menu_forced_subtitle = /** @type {(inputs: Context_Menu_Forced_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtítulo forzado`)
};

const zh_cn2_context_menu_forced_subtitle = /** @type {(inputs: Context_Menu_Forced_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`强制字幕`)
};

const ja_context_menu_forced_subtitle = /** @type {(inputs: Context_Menu_Forced_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`強制字幕`)
};

const hi_context_menu_forced_subtitle = /** @type {(inputs: Context_Menu_Forced_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनिवार्य उपशीर्षक`)
};

const pt_pt2_context_menu_forced_subtitle = /** @type {(inputs: Context_Menu_Forced_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legenda forçada`)
};

/**
* | output |
* | --- |
* | "Forced Subtitle" |
*
* @param {Context_Menu_Forced_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_forced_subtitle = /** @type {((inputs?: Context_Menu_Forced_SubtitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Forced_SubtitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_forced_subtitle(inputs)
	if (locale === "de") return de_context_menu_forced_subtitle(inputs)
	if (locale === "it") return it_context_menu_forced_subtitle(inputs)
	if (locale === "ru") return ru_context_menu_forced_subtitle(inputs)
	if (locale === "es") return es_context_menu_forced_subtitle(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_forced_subtitle(inputs)
	if (locale === "ja") return ja_context_menu_forced_subtitle(inputs)
	if (locale === "hi") return hi_context_menu_forced_subtitle(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_forced_subtitle(inputs)
	return en_context_menu_forced_subtitle(inputs)
});